// extracted by mini-css-extract-plugin
module.exports = {"background":"CircleBackground_background__2iaQe","overlay":"CircleBackground_overlay__21tVM"};